import React from 'react'

const Footer = (props) => (
    <footer id="footer" style={props.timeout ? {display: 'none'} : {}}>
      <ul className="icons">
        <li><a target="_blank" href="mailto:jeremyzander@gmail.com" className="icon fa-envelope"><span className="label">Email</span></a></li>
        <li><a target="_blank" href="https://github.com/jzander" className="icon fa-github"><span className="label">GitHub</span></a></li>
        <li><a target="_blank" href="tel:15167764428" className="icon fa-phone"><span className="label">Phone</span></a></li>
      </ul>
        <p className="copyright"><a href="mailto:jeremyzander@gmail.com">jeremy.zander@gmail.com</a></p>
    </footer>
)

Footer.propTypes = {
    timeout: React.PropTypes.bool
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js